/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class SocialShare extends HTMLElement {
  connectedCallback() {
    this.initShare();
  }
  initShare() {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile || !navigator.share) return;
    const socialLinks = document.querySelectorAll('.list-social__link');
    socialLinks.forEach(link => {
      link.addEventListener('click', async e => {
        e.preventDefault();
        try {
          await navigator.share({
            title: link.dataset.shareTitle,
            url: link.dataset.shareUrl
          });
        } catch (err) {
          console.log(err);
        }
      });
    });
  }
}
customElements.define('social-share', SocialShare);
/******/ })()
;